import { EditPencil } from "./EditPencil";
import { SummaryBox } from "./SummaryBox";

interface SummaryCardProps {
  icon: string;
  title: string;
  /** Renders the edit pencil (top-right) when provided. */
  onEdit?: () => void;
  /** Purple "active" tint per Figma — the Payment card while it's the step being edited. */
  highlighted?: boolean;
  /** Muted icon/title tone when the card has no data yet. */
  empty?: boolean;
  className?: string;
}

/**
 * Priced Booking Summary card — a SummaryBox (the same shell the draft-step summary uses,
 * so both variants look identical) plus the standard edit-pencil action.
 */
export const SummaryCard = ({
  icon,
  title,
  onEdit,
  highlighted = false,
  empty = false,
  className,
  children,
}: React.PropsWithChildren<SummaryCardProps>) => (
  <SummaryBox
    icon={icon}
    title={title}
    state={highlighted ? "active" : empty ? "empty" : "filled"}
    className={className}
    action={onEdit && <EditPencil label={`Edit ${title}`} onClick={onEdit} />}
  >
    {children}
  </SummaryBox>
);
